import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, AlertTriangle, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

/**
 * TenantNotFound - Shown when tenant slug doesn't exist or is suspended
 */
const TenantNotFound = ({ error }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-8 h-8 text-amber-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Organization Not Found
        </h1>
        
        <p className="text-gray-600 mb-6">
          {error || "The organization you're looking for doesn't exist or has been suspended."}
        </p>
        
        <div className="space-y-3">
          <Link to="/signup">
            <Button className="w-full bg-blue-600 hover:bg-blue-700">
              <Building2 className="w-4 h-4 mr-2" />
              Register Your Organization
            </Button>
          </Link>
          
          <p className="text-sm text-gray-500">
            Already have an account?{' '}
            <a href="/cherry-holidays/login" className="text-blue-600 hover:underline">
              Sign in to Cherry Holidays
            </a>
          </p>
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-400">
            Looking for a different organization? Check with your administrator for the correct URL.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TenantNotFound;
